(function () {
  // Genuinely-sticky secondary page nav across Benefits...FAQ.
  //
  // Shopify sections render as independent sibling <div>s, so a plain
  // position: sticky nav has no tall shared containing block to stick
  // within -- it "unsticks" almost immediately and just scrolls away.
  // This pins the nav with position: fixed instead, based directly on
  // the scroll position of a start sentinel (the nav's own original
  // location) and an end sentinel (the top of the Support section).
  // The nav is pinned exactly when: start boundary passed AND end
  // boundary not yet passed.
  //
  // An IntersectionObserver was tried first but can't reliably detect
  // this: on a fast or instant scroll (anchor-link jump, scrollIntoView)
  // a sentinel can move from fully below the viewport to fully above it
  // without its intersection ratio ever leaving 0%, so the "crossed a
  // threshold" callback never fires. Checking getBoundingClientRect()
  // directly on scroll has no such gap.
  var shells = document.querySelectorAll('.pg-page-nav-shell');
  if (!shells.length) return;

  var endSentinel = document.querySelector('[data-pg-page-nav-end-sentinel]');
  var ticking = false;

  function update() {
    ticking = false;
    var pastEnd = endSentinel ? endSentinel.getBoundingClientRect().top < 0 : false;

    shells.forEach(function (shell) {
      var startSentinel = shell.querySelector('.pg-page-nav__sentinel-start');
      if (!startSentinel) return;
      var pastStart = startSentinel.getBoundingClientRect().top < 0;
      shell.classList.toggle('pg-page-nav--pinned', pastStart && !pastEnd);
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();
